﻿$.fn.dxCtrlPagePlaniti = function custom_dxCtrlPagePlaniti(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpageplaniti dx-ctrl");
        this.createInstance(new cdxCtrlPagePlaniti(this, option));
    }
    return this;
}

window.cdxCtrlPagePlaniti = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "planiti_page"

    var ctrlResize = null;

    function mConstruit() {
        container.empty();

        //$("<div style='width:100%;height:100%;'/>").appendTo(container).dxSplitter({
        //    orientation: "vertical",
        //    items: [{
        //        text: "Top Panel"
        //    },
        //    {
        //        splitter: {
        //            items: [{
        //                text: "Nested Left Panel"
        //            }, {
        //                text: "Nested Central Panel"
        //            }, {
        //                text: "Nested Right Panel"
        //            }
        //            ]
        //        }
        //    }
        //    ],
        //onResizeEnd: function(e) {
        //    console.log(e.component.instance().option("items[0].size"));
        //    console.log(e.component.instance().option("items[1].size"));
        //}
        //});

        ////$("<div style='width:100%;height:100%;'/>").appendTo(container).dxSplitter({
        ////    separatorSize: 30,
        ////    orientation:"horizontal",
        ////    items: [{
        ////        resizable: true,
        ////        size: '140px',
        ////        minSize: '70px',
        ////        template(itemData, itemIndex, itemElement) {
        ////            itemElementLeft = itemElement
        ////        }
        ////    }, {
        ////        resizable: true,
        ////        template(itemData, itemIndex, itemElement) {
        ////            itemElementRight = itemElement
        ////        }
        ////    }]
        ////})

        ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            context_grid: option.context_grid,
            withMarge: true,
            widthLeftInitial: 300
        }).dxCtrlSplitterResize2("instance")
        ctrlResize.mConstruitRight(function (contentElement) {
            contentElement.css("position", "relative")
            contentElement.css("box-sizing", "border-box")
        })
        ctrlResize.mConstruitLeft(function (contentElement) {
            mConstruitMenu(contentElement)
        })
    }

    function mConstruitMenu(contentElement) {
        $("<div/>").appendTo(contentElement).dxCtrlMenuPlaniti({
            bddCtrl: option.bddCtrl,
            context_grid: option.context_grid + "_menu",
            onSelectChange: function (itemData) {
                Me.mSelect(itemData)
            }
        }).dxCtrlMenuPlaniti("instance")
    }

    this.mSelect = function (itemData) {
        if (!itemData) { ctrlResize.mConstruitRight(function (contentElement) { contentElement.empty() }) }
        else {
            ctrlResize.mConstruitRight(function (contentElement) {
                switch (itemData.id) {
                    case 0: //agenda planiti
                        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid + "_agenda"] == "undefined") option.bddCtrl.utiCourantParaJson[option.context_grid + "_agenda"] = {}
                        option.bddCtrl.utiCourantParaJson[option.context_grid + "_agenda"].lst_agenda_selected = [2]
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].lstidutiref == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid + "_agenda"].lstidutiref = [utiCourant.id_utilisateur]
                        var dxPlaniti = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlAgenda({
                            context_grid: option.context_grid + "_agenda",
                            isAgendaPlaniti: true,
                            bddCtrl: option.bddCtrl,
                            allowGroup:false
                        }).dxCtrlAgenda("instance")
                        dxPlaniti.mUpdateDataSource()
                        break;
                    case 1: //aagenda utilisateur
                        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid + "_agenda_uti_planiti"] == "undefined") option.bddCtrl.utiCourantParaJson[option.context_grid + "_agenda_uti_planiti"] = {}
                        var agenda = option.bddCtrl.mGetArray("agenda").filter(function (o) { return o.id_utilisateur_ref == option.bddCtrl.utiCourant.id_utilisateur })[0]
                        option.bddCtrl.utiCourantParaJson[option.context_grid + "_agenda_uti_planiti"].lst_agenda_selected = [agenda.id_agenda]
                        var dxAgendaUti = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlAgenda({
                            context_grid: option.context_grid + "_agenda_uti_planiti",
                            bddCtrl: option.bddCtrl,
                            allowGroup:false
                        }).dxCtrlAgenda("instance")
                        dxAgendaUti.mUpdateDataSource()
                        break;
                    case 2: //liste évènement
                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlGridPlaniti({
                            context_grid: option.context_grid + "_gridplaniti",
                            bddCtrl: option.bddCtrl,
                            allowFiltreUti: false
                        }).dxCtrlGridPlaniti("instance")
                        break;
                    case 3: //liste réunion
                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlGridPlanitiReunion({
                            context_grid: option.context_grid + "_gridplanitireunion",
                            bddCtrl: option.bddCtrl,
                        }).dxCtrlGridPlanitiReunion("instance")
                        break;
                }
            })
        }
    }

    this.element = function () { return container; }

    mConstruit();
}